import {ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit} from '@angular/core';
import {DemoService} from 'app/core/services/demo.service';
import {Router} from '@angular/router';
import {Subscription} from 'rxjs';
import {debounceTime} from 'rxjs/operators';

@Component({
    selector: 'leave-demo-account',
    templateUrl: './leave-demo-account.component.html',
    styleUrls: ['./leave-demo-account.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LeaveDemoAccountComponent implements OnInit, OnDestroy {
    currentHref: string;
    sub: Subscription = Subscription.EMPTY;

    constructor(
        public demo: DemoService,
        private router: Router,
        private cd: ChangeDetectorRef
    ) {}

    ngOnInit() {
        this.sub = this.router.events.pipe(debounceTime(0)).subscribe(event => {
            this.currentHref = window.location.pathname;
            this.cd.markForCheck();
        });
    }

    ngOnDestroy() {
        this.sub.unsubscribe();
    }
}
